import Game24 from './games/twentyfour/Game24'
import { Landing } from './Landing'

// Thin path router for the nerdle labs suite:
//   /labs      → games landing
//   /labs/24   → the 24-game
// No router library — a full page reload between landing and a game is fine for a static
// SPA. When the suite grows, add the game's slug here (and a card in Landing's GAMES).
function App() {
  const seg =
    typeof window !== 'undefined'
      ? window.location.pathname.replace(/\/+$/, '').split('/').pop() || ''
      : ''
  if (seg === '24') return <Game24 />
  return <Landing />
}

export default App
